import * as yup from "yup";
import { validarMoedaReal } from "../../core/utils/validarMoedaReal";

export const regiaoEntregaSchema = yup.object().shape({
    descricao: yup.string().required('A descrição é obrigatória'),
    preco: yup.string().test('preco', 'Valor inválido', (valor) => {
        return !validarMoedaReal(valor, 0.00, undefined, true);
    }),
});